import ModalLineAddColumn from './modal-line-add-column'
import ModalLineColumn from './modal-line-column'

const QuentnClose = ({ fields, setFields }) => {
  const optOption = [
    { value: 'status', label: 'Status' },
    { value: 'opprtunity', label: 'Opprtunity' },
  ]

  return (
    <div className="column-action">
      <div className="column-action-title">CloseCRM</div>
      {fields &&
        fields.map((e) => (
          <ModalLineColumn
            key={e.key}
            option={e.option}
            optionValue={e.optionValue}
            action={e.action}
            actionValue={e.actionValue}
            optOption={optOption}
            deleteCallback={() =>
              setFields(fields.filter((f) => f.key !== e.key))
            }
            optCallback={(c) => {
              setFields((fields) =>
                fields.map((m) =>
                  m.key === e.key ? { ...m, option: c.value } : m
                )
              )
            }}
            actCallback={(c) => {
              setFields((fields) =>
                fields.map((m) =>
                  m.key === e.key ? { ...m, action: c.value } : m
                )
              )
            }}
            //   trigger={e.trigger}
            //   triggerVal={e.triggerValue}
            //   action={e.action}
            //   actionVal={e.actionValue}
            //   optTrigger={optTrigger}
            //   optAction={optAction}
            //   optActCallback={(c) => {
            //     setDataFields((dataFields) =>
            //       dataFields.map((m) =>
            //         m.key === e.key ? { ...m, action: c.value } : m
            //       )
            //     )
            //   }}
            //   valueCallback={(c) => {
            //     setDataFields((dataFields) =>
            //       dataFields.map((m) =>
            //         m.key === e.key ? { ...m, triggerValue: c.target.value } : m
            //       )
            //     )
            //   }}
            //   valueActCallback={(c) => {
            //     setDataFields((dataFields) =>
            //       dataFields.map((m) =>
            //         m.key === e.key ? { ...m, actionValue: c.target.value } : m
            //       )
            //     )
            //   }}
          />
        ))}
      <ModalLineAddColumn
        callback={() => {
          setFields([
            ...fields,
            {
              key: new Date().getTime(),
              option: '',
              optionValue: '',
              action: '',
              actionValue: '',
            },
          ])
        }}
      />
    </div>
  )
}

export default QuentnClose
